import React, { useState, useEffect } from 'react';
import { useObjectStore } from "../zustand/objects";
import { setSpecificUserProjectGuestAccessAPI, getSpecificUserProjectGuestAccessAPI } from "../api";
import { Group, Button, Text, Switch, TextInput, ActionIcon, Modal, Stack, Box } from '@mantine/core';
import { getStripeSubStatus, getProjectGuestsAPI, saveUserGuestsAPI, setGuestProjectsAPI, deleteGuestProjectsAPI, getGoogleAuthURL, getMiroAuthURL } from "../api";
import {
  editorModalShell,
  editorModalStrongTitleStyles,
  editorModalBorder,
  editorModalFootnoteBoxStyle,
  editorModalMdTextInputStyles,
  editorModalPrimaryButtonStyles,
  editorModalPrimaryButtonStylesMd,
  editorModalSecondaryButtonStyles,
} from "../styleFile";

import { IconX, IconUserCircle } from '@tabler/icons-react';

export default function ShareModal({ projectKey }) {
    const primaryTextColor = "var(--mbx-modal-primary-text, #111827)";
 
    const {
        switchShareModalOpen,
        shareModalOpen
    } = useObjectStore();

    const onShareCancel = () => {
        switchShareModalOpen()
    }

    const [guests, setGuests] = useState([])

    const getGuests = () => {
        getProjectGuestsAPI(projectKey).then(res => res && res.projectGuests.length > 0 ? setGuests(res.projectGuests) : setGuests([])
        )
    }

    const [loggedOutAccess, setLoggedOutAccess] = useState(false)
    const [subscription, setSubscription] = useState(null)

    useEffect(() => {
        getStripeSubStatus().then((res) => setSubscription(res.plan))
        getGuests()
        getSpecificUserProjectGuestAccessAPI(projectKey)
        .then(res => setLoggedOutAccess(res))
    }, [])

    async function setNewGuests(newUser) {
        setGuests([guests.push(newUser)]) 
    }

    const addGuestAccess = (newUser) => {
        setGuestProjectsAPI({userEmail: newUser, projectKey: projectKey})
 }
    const submitUsers = (newUser) => {
        setNewGuests(newUser).then((e) =>
            saveUserGuestsAPI({
                projectKey: projectKey,
                // projectGuests: guests
                newUser: newUser
            })
            .then(r =>
                getProjectGuestsAPI(projectKey).then(res => {
                    setGuests(res.projectGuests)
                }
                )
            .then(r =>
                addGuestAccess(newUser)
                )
            ))
    } 

    const removeGuestUser = (email) => {
        
        const updatedGuests = guests.filter(guest => guest !== email);
        // const updatedGuests = guests.filter(guest => guest.email !== email);
        setGuests(updatedGuests)
        saveUserGuestsAPI({
            delete: true,
            projectKey: projectKey,
            newUser: email
        })
        deleteGuestProjectsAPI({
            userEmail: email,
            projectKey: projectKey
        })

    }

    const updateGuestAccess = (email, newAccess) => {
        const updatedGuests = guests.map(guest => {
          if (guest.email === email) {
            return {...guest, access: newAccess}; 
          }
          return guest; // Return the original user object
        });
        setGuests(updatedGuests); // Update the state variable with the new array of users
        saveUserGuestsAPI({
            projectKey: projectKey,
            projectGuests: updatedGuests
        });
      }

    const accessOptions = ['preview', 'edit']

    const handleChangeLoggedOutValue = (e) => {
        setSpecificUserProjectGuestAccessAPI({
            projectKey: projectKey,
            loggedOutGuestAccess: e.target.checked})
            setLoggedOutAccess(e.target.checked)
    }



    const guestEmailDisabled = subscription === "personal" && guests.length > 0;

    return (
        <Modal
            opened={shareModalOpen}
            onClose={onShareCancel}
            title="Share this project"
            withCloseButton
            size={560}
            radius={editorModalShell.radius}
            centered={editorModalShell.centered}
            overlayProps={editorModalShell.overlayProps}
            styles={editorModalStrongTitleStyles}
        >
            <Stack gap={0}>
                <Stack
                    gap="md"
                    p={20}
                    style={{
                        maxHeight: "min(52vh, 380px)",
                        overflow: "auto",
                    }}
                >
                    <Box p="md" style={editorModalFootnoteBoxStyle}>
                        <Text size="xs" c="dimmed" style={{ lineHeight: 1.55 }}>
                            This is a 3D ideas tool. It is not designed to secure sensitive content. Avoid creating,
                            uploading, or sharing sensitive content.{" "}
                            <a href="https://www.matchboxxr.com/policies" target="_blank" rel="noreferrer">
                                Read more
                            </a>
                            .
                        </Text>
                    </Box>

                    <div>
                        <Text size="sm" fw={600} c={primaryTextColor} mb={6}>
                            Guest access
                        </Text>
                        <Text size="sm" c="dimmed" style={{ lineHeight: 1.45 }}>
                            Max of 1 guest editor for this tier.
                        </Text>
                    </div>

                    <form
                        onSubmit={(e) => {
                            e.preventDefault();
                            const data = new FormData(e.currentTarget);
                            const email = data.get("guestEmail");
                            if (email && String(email).trim()) submitUsers(String(email).trim());
                        }}
                    >
                        <Stack gap={8}>
                            <Text component="label" htmlFor="share-guest-email" size="sm" fw={600} c={primaryTextColor}>
                                Guest editor email
                            </Text>
                            <Group align="stretch" gap="sm" wrap="nowrap">
                                <TextInput
                                    id="share-guest-email"
                                    name="guestEmail"
                                    disabled={guestEmailDisabled}
                                    radius="md"
                                    size="md"
                                    type="email"
                                    placeholder="name@example.com"
                                    autoComplete="email"
                                    style={{ flex: 1, minWidth: 0 }}
                                    styles={editorModalMdTextInputStyles}
                                />
                                <Button type="submit" radius={4} disabled={guestEmailDisabled} styles={editorModalPrimaryButtonStylesMd}>
                                    Add
                                </Button>
                            </Group>
                        </Stack>
                    </form>

                    <Stack gap={8}>
                        {shareModalOpen && guests && guests.length > 0 ? (
                            guests.map((mapped, i) =>
                                mapped === "" ? null : (
                                    <Group key={i} justify="space-between" wrap="nowrap" gap="sm">
                                        <Group gap={8} wrap="nowrap" style={{ minWidth: 0 }}>
                                            <IconUserCircle size={20} color="#6b7280" style={{ flexShrink: 0 }} />
                                            <Text size="sm" fw={500} truncate>
                                                {mapped}
                                            </Text>
                                        </Group>
                                        <ActionIcon
                                            variant="light"
                                            color="gray"
                                            size="md"
                                            radius="md"
                                            aria-label="Remove guest"
                                            onClick={() => removeGuestUser(mapped)}
                                        >
                                            <IconX size={18} />
                                        </ActionIcon>
                                    </Group>
                                )
                            )
                        ) : (
                            <Text size="sm" c="dimmed">
                                No guest editors yet.
                            </Text>
                        )}
                    </Stack>
                </Stack>

                <Box
                    px={20}
                    pb={20}
                    pt="lg"
                    style={{
                        borderTop: `1px solid ${editorModalBorder}`,
                    }}
                >
                    <Group justify="space-between" align="center" gap="md" wrap="wrap">
                        <Switch
                            color="dark"
                            size="sm"
                            label="Logged-out preview"
                            styles={{ label: { fontSize: 13 } }}
                            checked={!!loggedOutAccess}
                            onChange={(e) => handleChangeLoggedOutValue(e)}
                        />
                        <Button
                            radius={4}
                            styles={editorModalSecondaryButtonStyles}
                            onClick={() => navigator.clipboard.writeText(`https://mbxr.io/story/${projectKey}`)}
                        >
                            Copy preview link
                        </Button>
                    </Group>
                </Box>
            </Stack>
        </Modal>
    );
}


export const MiroShareButton = ({projectKey}) => {

    const popup = (url) => window.location.replace(url)
    const handleClick = () => {
        getMiroAuthURL(projectKey).then((res) => popup(res))
    }
    
    return (  
        <Button
        onClick={() => handleClick()}
        radius={4}
        styles={editorModalPrimaryButtonStyles}
        style={{ marginTop: 20, marginBottom: 20 }}
        >Link to Miro</Button>
    )
}

export const GoogleShareButton = ({projectKey}) => {

    const popup = (url) => window.location.replace(url)
    // const popup = (url) => window.open(url, "popup", "popup=true")

    const handleClick = () => {
        getGoogleAuthURL(projectKey).then((res) => popup(res))
    }

    return (  
        <Button 
        onClick={() => handleClick()}
        radius={4}
        styles={editorModalPrimaryButtonStyles}
        style={{ marginTop: 20, marginBottom: 20 }}
        >Link to Google</Button>
    )
}








